import { useI18n } from "@/lib/i18n";

const TONES = {
  cancelled: "bg-red-50 text-[var(--error)]",
  pending_payment: "bg-amber-50 text-[#c97a00]",
  completed: "bg-[var(--surface-2)] text-[var(--text-2)]",
  confirmed: "bg-green-50 text-[var(--success)]",
};

export function StatusBadges({ booking: b, showPaymentWhenCancelled = false }) {
  const { t } = useI18n();
  return (
    <div className="flex gap-2 flex-wrap">
      <span data-testid={`booking-status-${b.id}`} className={`px-2.5 py-1 rounded-full text-xs font-bold ${TONES[b.status]}`}>{t(`st_${b.status}`)}</span>
      {(b.status !== "cancelled" || showPaymentWhenCancelled) && (
        <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${b.payment_status === "paid" ? "bg-[var(--brand-primary)] text-white" : "bg-[var(--brand-tertiary)] text-[var(--brand-primary)]"}`}>{t(`pay_${b.payment_status}`)}</span>
      )}
    </div>
  );
}
